import { footerProducts } from "//shopakaso.com/cdn/shop/t/25/assets/goc-shopify-linklists.js?v=47969834943355373271780912034"

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('gocFooter', function () {

    return {
      localName: "en",
      dialogTableVisible:false,
      selectedCountry: true,
      subscribeForm: {
        email: ""
      },

      expanded: "",
      onCollapseClick(titie) {
        this.expanded = this.expanded === titie ? "" : titie
      },
      isExpanded(titie) {
        return this.expanded === titie
      },
      isShow(        item, lang
      ){
        if(item.title == "User Rewards" && lang != 'en') {
          return false
        } else if (item.title == 'Long-term Outdoor Partnership' && (lang != 'en' || lang != 'ja') ) {
          return false
        } else if (item.title == "Become Our Reseller" && lang != 'en') {
          return false
        } else if (item.title == "Check / Track Order" && lang != 'en') {
          return false
        } else {
          return true
        }
      },
      showLanguageDialog() {
        publish(PUB_SUB_EVENTS.languageDialog, {
          data: {
            show: true,
          },
        });
      }
    }
  })
}

document.addEventListener('alpine:init', main)
